import {
  DropdownMenu as Root,
  DropdownMenuTrigger as Trigger,
  DropdownMenuContent as Content,
  DropdownMenuItem as Item,
  DropdownMenuLabel as Label,
  DropdownMenuSeparator as Separator,
  DropdownMenuGroup as Group,
} from "@radix-ui/react-dropdown-menu";

export const DropdownMenu = Root;
export const DropdownMenuTrigger = Trigger;
export const DropdownMenuContent = Content;
export const DropdownMenuItem = Item;
export const DropdownMenuLabel = Label;
export const DropdownMenuSeparator = Separator;
export const DropdownMenuGroup = Group;
